import {
   DeleteDatabasesInParams,
   DeleteDatabasesOutParams
} from '../../utils/params/DeleteDatabasesParams';

import {Recurso} from 'lib.common/dist/CleanArch';
import {ErrDevGenerico} from 'lib.common/dist/errorHandler';
import {GestionarAppDbsRepository} from '../../bussines/repository/GestionarAppDbsRepository';
import {GestionarAppDtSource} from '../../bussines/dataSources/GestionarAppDtSource';

export class GestionarAppDbsRepositoryImpl implements GestionarAppDbsRepository {
   private dataSourceGql: GestionarAppDtSource;

   constructor({dataSourceGql}: {dataSourceGql?: GestionarAppDtSource}) {
      if (!dataSourceGql) {
         throw new Error('Debe proporcionar al menos un data source.');
      }

      this.dataSourceGql = dataSourceGql;
   }

   async deleteDbs(input: DeleteDatabasesInParams): Promise<Recurso<DeleteDatabasesOutParams>> {
      try {
         const deletedInfo = await this.dataSourceGql.deleteDbs(input);

         if (deletedInfo.isSuccess()) {
            return Recurso.fromData<DeleteDatabasesOutParams>(deletedInfo.data!);
         }
         return Recurso.fromError<DeleteDatabasesOutParams>(deletedInfo.error!);
      } catch (error) {
         return Recurso.fromError<DeleteDatabasesOutParams>(new ErrDevGenerico(error as Error));
      }
   }
}
